import React from "react";
import Topbar from "./Topbar";
import ResponsiveSidebar from "./ResponsiveSidebar";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

const Portal = ({ children }) => {
  const location = useLocation();
  return (
    <div>
      {location.pathname === "/login" ? (
        children
      ) : (
        <div className="bg-gray-100 min-h-screen">
          <Sidebar>
            <div className="overflow-y-auto flex-1 flex flex-col">
              <main>{children}</main>
            </div>
          </Sidebar>
        </div>
      )}
    </div>
  );
};

export default Portal;
